import { getNewAccessTokenRequest } from './auth';
import {
    clearLocalStorage,
    getItemFromLocalStorage,
    setItemToLocalStorage,
} from './storage';

export default class TokenService {
    static ACCESS_TOKEN = 'access_token';

    static REFRESH_TOKEN = 'refresh_token';

    static getRefreshToken() {
        return getItemFromLocalStorage(this.REFRESH_TOKEN);
    }

    static getAccessToken() {
        return getItemFromLocalStorage(this.ACCESS_TOKEN);
    }

    static clear() {
        clearLocalStorage();
    }

    static storeAccessToken(accessToken) {
        if (accessToken !== undefined) {
            setItemToLocalStorage(this.ACCESS_TOKEN, accessToken);
        }
    }

    static storeRefreshToken(refreshToken) {
        if (refreshToken !== undefined) {
            setItemToLocalStorage(this.REFRESH_TOKEN, refreshToken);
        }
    }

    static getNewToken() {
        return new Promise((resolve, reject) => {
            const oldRefreshToken = this.getRefreshToken();
            getNewAccessTokenRequest(oldRefreshToken)
                .then(response => {
                    const { accessToken, refreshToken } = response;
                    this.storeAccessToken(accessToken);
                    this.storeRefreshToken(refreshToken);
                    resolve(accessToken);
                })
                .catch(reject);
        });
    }
}
